import { type InitOptions } from 'i18next';

// 静态导入语言包
import zhCommon from './locales/zh/common.json';
import enCommon from './locales/en/common.json';

// 定义支持的语言
const SUPPORTED_LANGUAGES = ['zh', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

// 静态资源对象
const resources = {
    zh: {
        common: zhCommon,
    },
    en: {
        common: enCommon,
    },
};

export const i18nConfig: InitOptions = {
    resources,
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: 'zh',
    interpolation: {
        escapeValue: false, // React 已经处理了 XSS
    },
    fallbackNS: 'common',
    defaultNS: 'common',
    ns: ['common'],
    detection: {
        order: ['cookie', 'localStorage'], // 只判断cookie和localStorage
    },
    // 添加这些配置来避免警告
    debug: false,
    returnEmptyString: false,
    returnNull: false,
};
